/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SunIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "sun", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 4, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 2.5V5.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 19.5V22.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M2.5 12.5H5.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 12.5H22.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5.42893 19.5711L7.55025 17.4497", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.4497 7.55025L19.5711 5.42893", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5711 19.5711L17.4497 17.4498", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.55025 7.55026L5.42893 5.42894", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SunIcon);
export default ForwardRef;
//# sourceMappingURL=sunIcon.js.map